import Vue from './common/vue-common';
import Catalog from "./components/catalog/Catalog";
import RenderNotifier from "./components/common/RenderNotifier";

new Vue({
    el: '#catalog-vue',
    components: { 'catalog': Catalog, 'render-notifier': RenderNotifier }
});
